import SettingType from '@settings/models/setting-type.enum';
import { getSettingByType } from '@settings/services/settingServices';
import { useQuery } from '@tanstack/react-query';

export const useGetGeneralSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['settings-general'],
    queryFn: () => getSettingByType(SettingType.GENERAL),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetEnterpriseSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['settings-enterprise'],
    queryFn: () => getSettingByType(SettingType.ENTERPRISE),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetCandidateSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['settings-candidate'],
    queryFn: () => getSettingByType(SettingType.CANDIDATE),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetCreditsSettings = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['settings-credit'],
    queryFn: () => getSettingByType(SettingType.CREDIT),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
